import React from 'react'
import classNames from 'classnames'
import './CardFlow.less'
import { Box } from 'front-end/src/components'
import { brandColors } from 'shared/basicPalette'
import { css } from '@emotion/react'

export interface ICardFlowProps {
  cards: React.ReactNode[]
  focusedTopicIndex: number
  className?: string
  cardsConnected?: boolean
}

const CardFlow = ({
  cards,
  className,
  focusedTopicIndex,
  cardsConnected = false
}: ICardFlowProps) => {
  const cssClasses = classNames('CardFlow', className)
  return (
    <Box className="CardFlow__wrapper">
      <Box
        className={cssClasses}
        ref={(refBox) => {
          if (refBox) {
            const listItem = refBox?.getElementsByClassName('CardFlow__item')[0]
            // No listItem might happen in pathways with no resources in it
            if (!listItem) {
              return
            }
            const scrollTo =
              focusedTopicIndex *
              (listItem.clientWidth +
                parseFloat(window.getComputedStyle(listItem).marginRight))
            if (scrollTo > 0 && refBox.scrollLeft === 0) {
              refBox.scrollBy({ left: scrollTo, behavior: 'smooth' })
            }
          }
        }}
      >
        <Box className="CardFlow__items">
          {cards.map((card, idx) => {
            return (
              <Box
                position="relative"
                key={idx}
                className="CardFlow__item"
                css={css`
                  > a {
                    z-index: 1;
                  }
                `}
                _after={
                  cardsConnected && idx < cards.length - 1
                    ? {
                        content: '""',
                        w: '32px',
                        h: '2px',
                        bgColor: brandColors.grey['300'],
                        position: 'absolute',
                        left: '100%',
                        top: '50%',
                        display: 'block'
                      }
                    : undefined
                }
              >
                {card}
              </Box>
            )
          })}
          {/* Spacer */}
          <Box minW="16px" />
        </Box>
      </Box>
    </Box>
  )
}

export default CardFlow
